import React, { PropsWithChildren, useEffect, useRef, useState } from "react"

import { styled } from "@mui/styles"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { IconButton } from "../../molecules"
import { MuiIcon } from "../MuiIcon"

interface IProps {
  collapsedSize?: number
  html?: string
  textClassName?: string
  id?: string
}

export const ExpandableText = ({
                                 collapsedSize = COLLAPSED_SIZE,
                                 html,
                                 textClassName = "",
                                 children,
                                 ...props
                               }: PropsWithChildren<IProps>) => {

  const ref = useRef<HTMLDivElement>(null)
  const [expanded, setExpanded] = useState<boolean>(false)
  const [expandButton, showExpandButton] = useState<boolean>(false)
  const { i18n } = useTranslations()

  useEffect(() => {
    showExpandButton((ref.current?.offsetHeight || 0) > collapsedSize)
  }, [])

  const muiIcon = expanded
    ? <MuiIcon.ArrowDropDown fontSize={"small"} />
    : <MuiIcon.ArrowRight fontSize={"small"} />

  const title = expanded
    ? i18n("General:Collapse")
    : i18n("General:Expand")

  const buttonSize = (collapsedSize || 0) > 32
    ? 32
    : collapsedSize

  return <StyledWrapper className={`${expanded ? "expanded" : ""}`}
                        style={{ height: `${collapsedSize || 0}px` }}>
    {
      <IconButton
        style={{ display: expandButton ? "flex" : "none" }}
        sx={{ width: `${buttonSize || 0}px`, height: `${buttonSize || 0}px` }}
        title={title}
        muiIcon={muiIcon}
        onClick={() => setExpanded(!expanded)} />
    }
    <StyledText ref={ref}
                className={`${expandButton && !expanded ? "spread" : ""} ${textClassName}`}>
      {children || ""}
      {html && <div id={props.id} dangerouslySetInnerHTML={{ __html: html }} />}
    </StyledText>
  </StyledWrapper>
}

const StyledText = styled("div")({
  height: "fit-content",

  "&:not(.spread)": {
    "& > div": {
      "& > p:first-of-type": {
        margin: 0
      }
    }
  },

  "&.spread": {
    "& > div": {
      "& > p:first-of-type": {
        width: "fit-content",

        "&:after": {
          content: "'...'"
        }
      }
    }
  }
})

const StyledWrapper = styled("div")({
  display: "flex",
  overflowY: "hidden",

  "&.expanded": {
    height: "fit-content !important",
    overflowY: "visible",
    lineHeight: "inherit"
  }
})

const COLLAPSED_SIZE = 16
